var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.627 20.838H4.371c-.813 0-1.473-.66-1.473-1.472V6.662c0-.813.66-1.473 1.473-1.473h15.256c.813 0 1.473.66 1.473 1.473v12.704c0 .813-.66 1.472-1.473 1.472Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.288 20.49H4.71c-.777 0-1.406-.63-1.406-1.407V6.944c0-.777.63-1.406 1.406-1.406h14.576c.777 0 1.407.63 1.407 1.406v12.138c0 .776-.63 1.406-1.406 1.406Z",
  fill: "url(#b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m20.113 9.299-3.67-6.356a.885.885 0 0 0-1.209-.324l-11.57 6.68h16.45Z",
  fill: "url(#c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.898 14.414H21.1v-4.82c0-.61-.494-1.102-1.102-1.102H4c-.608 0-1.102.493-1.102 1.101v4.821Z",
  fill: "url(#d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.898 12.601v6.765c0 .813.66 1.472 1.473 1.472h15.256c.813 0 1.473-.66 1.473-1.472V12.6a.91.91 0 0 0-.91-.91H3.808a.91.91 0 0 0-.91.91Z",
  fill: "url(#e)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.112 22.489 4.335 21.005a1.624 1.624 0 0 1-1.437-1.613V6.552c0 .276.207.508.481.54l14.108 1.639c.819.095 1.437.789 1.437 1.613v10.532c0 .97-.847 1.725-1.812 1.613Z",
  fill: "url(#f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.112 19.924 4.335 18.441a1.624 1.624 0 0 1-1.437-1.614v2.565c0 .824.618 1.518 1.437 1.613l12.777 1.484a1.624 1.624 0 0 0 1.812-1.613V18.31c0 .971-.847 1.726-1.812 1.613Z",
  fill: "url(#g)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "m15.499 4.69-1.883 1.024a.505.505 0 1 1-.483-.887l1.883-1.025a.505.505 0 1 1 .483.888Z",
  fill: "#61DB99"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 8.907,
  y1: 12.117,
  x2: 16.147,
  y2: 15.983,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF975C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F63"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 12.806,
  y1: 6.357,
  x2: 12.517,
  y2: 8.744,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB92D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD99D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 11.888,
  y1: 6.427,
  x2: 11.888,
  y2: 8.245,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A7F3CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#61DB99"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 11.999,
  y1: 9.575,
  x2: 11.999,
  y2: 13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0E89DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#036"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 11.999,
  y1: 13.364,
  x2: 11.999,
  y2: 18.654,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0E89DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#036"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 9.999,
  y1: 12.5,
  x2: 18.999,
  y2: 22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF975C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F63"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 10.696,
  y1: 20.55,
  x2: 10.417,
  y2: 22.684,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BE3F45",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BE3F45"
})))));
export default SvgWallet;